import React from 'react';
import { Link } from 'gatsby';

import PropTypes from 'prop-types';

const Footer = ({ openModalToggle }) => (
  <nav className="footer">
    <div className="container ">
      <div className="footer-content">
        <h3>
          <div className="tilt-text">Ready to</div>
          See Cliphire-recruit
          <br />
          in action?
        </h3>
        <button
          type="button"
          onClick={openModalToggle}
          className="button button-green">
          Join Waitlist
        </button>
      </div>
      <div className="footer-nav">
        <div className="top-footer flex-row col">
          <Link to="/">
            <img src="/img/cliphire-recruit-logo-white.svg" alt="" />
          </Link>
          <a href="mailto:hello@cliphire.co" className="contact-us">
            Contact Us
          </a>
        </div>
        <div className="bottom-footer flex-row col">
          <div className="footer-links flex-row col">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-of-service">Terms of Service</Link>
            <Link to="/cookie-policy">Cookie Policy</Link>
            <Link to="/acceptable-use-policy">Acceptable Use Policy</Link>
          </div>
          <div className="footer-logo">
            <a
              href="https://www.linkedin.com/company/clip-hire/"
              target="_blank"
              rel="noopener noreferrer">
              <img src="/img/linkedin-logo-footer.svg" alt="linkedin" />
            </a>
            <a
              href="https://www.facebook.com/cliphire"
              target="_blank"
              rel="noopener noreferrer">
              <img src="/img/facebook-logo.svg" alt="facebook" />
            </a>
            <a
              href="https://twitter.com/Clip_Hire"
              target="_blank"
              rel="noopener noreferrer">
              <img src="/img/twitter-logo.svg" alt="twitter" />
            </a>
          </div>
        </div>
      </div>
    </div>
  </nav>
);

Footer.propTypes = {
  openModalToggle: PropTypes.func.isRequired,
};

export default Footer;
